import PostMediaForm from "./post-media-form";

export default PostMediaForm;